module.exports = __webpack_public_path__ + "img/1-4.0186948d.svg";